
<template>
  <div id="pageSearchTitle">
    <div class="titleLeft">
      <img
        v-if="isBeijing"
        @click="toHome"
        class="titleLeftImg"
        src="@/assets/mallLogo2.png"
        alt=""
      />
      <img
        v-else
        @click="toHome"
        class="titleLeftImg"
        src="@/assets/mallLogo.png"
        alt=""
      />
      <span class="titleLeftText">{{ title }}</span>
    </div>
    <div v-if="!hideSearch" class="titleCenter">
      <div
        @mouseover="
          () => {
            showAnotherSeach = true;
          }
        "
        @mouseleave="
          () => {
            showAnotherSeach = false;
          }
        "
        class="searchTitleLeft"
      >
        <div>
          <el-button
            type="plain"
            :style="{
              'border-radius': '0',
              width: '80px',
              borderLeft: 'none',
              borderTop: 'none',
              borderBottom: 'none',
              backgroundColor: 'transparent',
            }"
            :size="searchSize ? searchSize : 'small'"
            >{{ this.$store.state.isGoodsSearch ? "商品" : "店铺" }}
            <i
              :class="
                showAnotherSeach ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
            ></i
          ></el-button>
        </div>
        <div class="storeSeacrhBox">
          <div class="storeSeacrhBoxContainer" v-show="showAnotherSeach">
            <el-button
              type="plain"
              @click="selectisGoodsSearch"
              :style="{ 'border-radius': '0', width: '80px' }"
              :size="searchSize ? searchSize : 'small'"
              >{{
                this.$store.state.isGoodsSearch ? "店铺" : "商品"
              }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="titleCenterInputBox">
        <el-input
          @input="SearchPageFocus"
          @blur="SearchPageBlur"
          clearable
          @clear="closeSearchStore"
          v-model="input"
          :style="{ width: `${width || 450}px` }"
          :size="searchSize ? searchSize : 'small'"
        >
          <span :style="{ marginLeft: 60 }" slot="prefix"></span>
        </el-input>
      </div>
      <el-button
        type="danger"
        @click="toSearchPage"
        :style="{ 'border-radius': '0', width: '80px' }"
        :size="searchSize ? searchSize : 'small'"
        >搜索</el-button
      >
      <div
        class="searchStore"
        :class="searchStoreabc ? 'searchStoreShow' : 'searchStoreDown'"
      >
        <div
          class="searchStoreDropdown"
          v-for="item in storeLists"
          @click="toStoreContentaa(item)"
          :key="item.storeid"
        >
          <div>{{ item.s_name }}</div>
        </div>
      </div>
    </div>
    <div
      v-if="!hideCart"
      @click="toCart"
      :class="['titleRight', showCart ? '' : 'hidden']"
    >
      <el-badge :value="totalNum" class="item" type="danger">
        <div class="cartText">我的购物车</div>
      </el-badge>
    </div>
  </div>
</template>

<script>
import { getDate, getCity, isBeijing, queryMyGoodsList } from "@/api/api";
import { mapState } from "vuex";
export default {
  props: [
    "hideCart",
    "title",
    "hideSearch",
    "searchSize",
    "width",
    "showCart",
    "placeholder",
  ],
  mounted() {
    this.isBeijing = isBeijing;
    this.initValue();
  },
  data() {
    return {
      input: "",
      isBeijing: "",
      showAnotherSeach: false, //是否显示额外的搜索选择框
      storeLists: [],
      searchStoreabc: false,
    };
  },
  computed: {
    ...mapState(["cartList"]),
    totalNum() {
      return this.$getCartInfo(this.cartList).num;
    },
  },
  watch: {},
  methods: {
    initValue() {
      // alert(this.title)
      if (this.placeholder) {
        this.input = this.placeholder;
      }
    },
    toHome() {
      this.$router.push("/");
    },
    toCart() {
      this.$router.push("cart");
    },
    SearchPageFocus() {
      // searchStoreabc = !searchStoreabc;

      if(this.input.trim()==""){
        this.searchStoreabc=false;
        return false
      }
      if (this.$store.state.isGoodsSearch == false) {
        this.searchStoreabc = true;
      }
      // console.log(encodeURI(this.input))
      // this.searchStoreabc=true;
      let that = this;
      let url = queryMyGoodsList;
      let data = {
        keyword: this.input.trim(),
        pageSize: '5',
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      }).then((res) => {
        console.log(res);
        let { data } = res.data;
        console.log("dataf", data);
        this.storeLists = data;
      });
    },
    SearchPageBlur() {
      if (this.input == "") {
        this.searchStoreabc = false;
      }
    },

    toSearchPage() {
      if (this.$store.state.isGoodsSearch == false) {
        // this.$router.push("searchstore");
        // this.$store.commit("searchInputChange",this.input);
        this.$emit("child-event", this.input);
        // console.log(this.input+false)
        // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa")
        console.log("正确")
        this.$router.push({
          name: "searchStore",
          query: {
            storeName: this.input,
          },
        });
      } else {
        console.log(true);
        this.$emit("goodschild-event", this.input);
        this.$router.push({
          name: "searchCommodity",
          query: {
            typeName: this.input,
          },
        });
      }
      this.searchStoreabc=false;
    },
    toStoreContentaa(item) {
      console.log("aaaa");
      // this.$router.push({
      //   name: "storeHomePage",
      //   query: {
      //     store_id: item.storeId,
      //   },
      // });
      this.input=item.s_name;
      this.searchStoreabc=false;
    },
    closeSearchStore(){
      this.searchStoreabc=false
    },
    selectisGoodsSearch() {
      console.log(this.$store.state.isGoodsSearch);
      if (this.$store.state.isGoodsSearch == true) {
        this.$store.commit("isFalse");
      } else {
        this.$store.commit("isTrue");
      }
    },
  },
};
</script>

<style lang='less' scoped>
#pageSearchTitle {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  .titleCenter {
    display: flex;
    position: relative;
    .searchStore {
      position: absolute;
      top: 32px;
      left: 80px;
      z-index: 999;
      width: 509px;
      padding-left: 10px;
      background-color: rgba(255, 255, 255,0.95);
      .searchStoreDropdown {
        color: rgb(85, 84, 84);
        margin-top: 3px;
        margin-bottom: 4px;
        cursor:pointer;
      }
    }
  }
  .searchStoreShow {
    display: block!;
  }
  .searchStoreDown {
    display: none;
  }
  .cartText {
    color: #666;
    font-size: 14px;
  }
  .cartText:hover {
    color: #f40;
    text-decoration: underline;
    cursor: pointer;
  }
  .titleCenterInputBox {
    display: inline-block;

    // width: 350px;
  }
  .titleRight {
    margin-right: 20px;
  }
  .titleLeftImg {
    height: 60px;
  }
  .titleLeft {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .titleLeftImg:hover {
    cursor: pointer;
  }
  .titleLeftText {
    font-size: 20px;
    font-weight: 700;
    color: #f70;
    margin-left: 5px;
    position: relative;
  }
  .hidden {
    visibility: hidden;
  }
  .searchTitleLeft {
    position: absolute;
    top: 1px;

    z-index: 1;
  }
  .storeSeacrhBox {
    position: relative;
  }
  .storeSeacrhBoxContainer {
    position: absolute;
  }
}
</style>


<style>
.searchStore a {
  color: #000 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/components/PageSearchTitle.vue